__turbopack_context__.v({
  "className": "THo1pq_className",
  "variable": "THo1pq_variable",
});
